import React from "react";

import kyvOnChain from "../helper/kyvOnChain";
import kyvHelper from "../helper/kyvOffChain";
import converterUtil from "../helper/converterUtil";
import terraUtils from "../helper/terraUtils";
import Table from "./Table";
import SvgButton from "./svgbutton";
import aprHelper from "../helper/aprHelper"

import { data } from "./model";
import TimestampChart from "./timestampbarchart";


const Screen = {
  VALIDATORS: "validators",
  VALIDATOR_METRICS: "validatorMetrics",
};

class ValidatorMetrics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading:true,
      validator: props.validator,
      rows: [],
      returnHook: props.returnHook,
    };
  }
  componentDidMount() {
    this.fetchData().then(
      (data) => {
        this.setState({ loading:false, rows: data, success: true });
      },
      (reason) => {
        this.setState({ rows: [], message: reason.toString(), success: false });
      }
    );
  }

  // shouldComponentUpdate() {
  //   return false;
  // }

  async fetchData() {
    return await kyvHelper
      .getKyvByValidator(this.state.validator)
      .then((data) => converterUtil.mapMetrics(data));
  }

  

  renderDataOrError(columns) {
    if (this.state.success) {
      return <TimestampChart columns={columns} data={this.state.rows} />;
    } else {
      return <div>{this.state.message}</div>;
    }
  }

  render() {
    const columns = [
      {
        Header: "Timestamp",
        accessor: "timestamp",
      },
      {
        Header: "Apr",
        accessor: "apr",
      },
    ];
    if(this.state.loading)
    {
      if (this.state.loading)
      {
        return (
          <div className="loaderWrapper"
            style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height:"100vh",
            backgroundColor:"#A7C7E7",
            position:"absolute",
            top:"0px",
            right:"0px",
            bottom:"0px",
            left:"0px",
          }}>
            {data.map((loader, index) => (
              
              <div key={loader.name + index} className="loaderBox">
                <loader.Component {...loader.props} />
              </div>
            ))} 
          </div>
        );
      }
    }
    else{
      const myStyle = {
        color: "white",
        // backgroundColor: "DodgerBlue",
        padding: "10px",
        fontFamily: "Sans-Serif"
      };
      return (
        <div style={myStyle}>
          <SvgButton
            onClick={() => {
              this.state.returnHook();
            }}
          >
            Back
          </SvgButton>
          {this.renderDataOrError(columns)}
        </div>
      );
    }
  }
}

class Validators extends React.Component {
  state = {
    loading:true,
    rows: [],
    screen: Screen.VALIDATORS,
  };

  componentDidMount() {
    this.fetchData().then((data) => {
      this.setState({ rows: data });
    });

  }

  async fetchData() {
    const validators = await kyvOnChain.fetchSortedValidators();
    const validatorsData = await aprHelper.mapValidatorsApr(validators);
    // console.log(validatorsData);
    this.setState({loading:false});
    return validatorsData;
  }
  returnToValidators() {
    this.setState({ loading:false,screen: Screen.VALIDATORS });
  }
  renderDashboard() {
    
    if (this.state.screen === Screen.VALIDATORS) {
      return this.renderValidators();
    } else {
        return (
        <ValidatorMetrics
          validator={this.state.validator}
          returnHook={() => this.returnToValidators()}
          />
        );
      
    }
  }
  renderValidators() {
    const columns = [
      {
        Header: "Address",
        accessor: "validator",
      },
      {
        Header: "Moniker",
        accessor: "moniker",
      },
      {
        Header: "Website",
        accessor: "website",
      },

    ];

    return (
      <Table
        columns={columns}
        data={this.state.rows}
        rowClickHandler={(data) => this.onRowClick(data)}
      />
    );
  }

  onRowClick(data) {
    this.setState({
      screen: Screen.VALIDATOR_METRICS,
      validator: data.validator,
    });
  }
  render() {

    if (this.state.loading)
    {
      return (
        <div className="loaderWrapper"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height:"100vh",
            backgroundColor:"#A7C7E7",
            position:"absolute",
            top:"0px",
            right:"0px",
            bottom:"0px",
            left:"0px",
        }}>
          {data.map((loader, index) => (
            
            <div key={loader.name + index} className="loaderBox">
              <loader.Component {...loader.props} />
            </div>
          ))}
        </div>
      );
    }
    else{
      return <div>
      {this.renderDashboard()}
      </div>;
    }
    
  }
}

export default Validators;
